<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-pa-sm card-crud">
          <q-card-section class="q-pb-lg card-table">
            <company-table
              v-if="nmInterface"
              ref="jtDataTable"
              class="table-crud"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParamCompany"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              @selection="selection"
              @action-button="actionButton"
              @show-message="showMessage"
            />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import CompanyTable from './CompanyTable'
const { pageTable } = JtCrud
@Component({
  components: { CompanyTable },
  mixins: [pageTable],
  props: {
    name: String,
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    forms: { type: Array, required: true },
    parent: Object,
    rowButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    cleanLayout: {
      required: false,
      type: Boolean,
      default: false
    }
  }
})
export default class CompanyTablePage extends Vue {
  get extraParamCompany () {
    delete this.extraParam.level
    return this.extraParam
  }
}
</script>
<style lang="stylus" scoped></style>
